export default __webpack_public_path__ + "./images/la.e20b52ed.png";